import { Outlet, useNavigate } from "react-router-dom";
import Header from "./common/Header";
import Footer from "./common/Footer";

export const AppLayout = () => {
  const navigate = useNavigate();
  const currentPath =
    window.location.pathname.includes("login") ||
    window.location.pathname.includes("admin");
  return (
    <>
      <Header />
      <Outlet />
      {(!currentPath && <Footer />) || ""}
    </>
  );
};
